module.exports = __webpack_public_path__ + "img/ch78.57da33ff.png";